import TextField, { TextFieldClear } from '@seaweb/coral/components/TextField';
import SearchIcon from '@seaweb/coral/icons/Search';
import { func, bool } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

// Note: No need to assign 'value' to SearchBox, as SearchBox can just assign the input value to a state in the component that imports it using onSearch.
// Moreover, assigning a value to SearchBox after being trimmed in onChange will cause the displayed input to be forcefully trimmed & prevent users from inputting space between words.
// If SearchBox doesn't have a value prop, the displayed input can still have space but the submitted value for search is trimmed (the currently used UX).
function SearchBox({ onSearch, fullWidth, ...otherProps }) {
  return (
    <TextField
      style={{ width: !fullWidth && 304 }}
      leftElement={<SearchIcon />}
      placeholder={<FormattedMessage {...messages.search} />}
      onChange={(e) => onSearch(e.target.value.trim())}
      rightElement={<TextFieldClear />}
      fullWidth={fullWidth}
      {...otherProps}
    />
  );
}

SearchBox.propTypes = {
  onSearch: func.isRequired,
  fullWidth: bool,
};

export default SearchBox;
